import { Avatar, Button, Checkbox, createStyles, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormHelperText, Grid, IconButton, Link, List, ListItem, ListItemAvatar, ListItemText, MenuItem, Radio, RadioGroup, StyledComponentProps, TextField, withStyles } from '@material-ui/core';
import { GridSize } from '@material-ui/core/Grid';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import { makeStyles, Theme } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { PleaseWait } from '../../comps/PleaseWait';
import { INamedEntity, ISupplier } from '../../main/entities';
import { transl } from '../../main/transl';
import { IOcResponse } from '../../services/CommSvc';
import { getOmnistore, useOmnistore } from '../../stores/Omnistore';
import { BranchAddForm, BranchDialog } from './BranchDialog';
import { branchDialogStore } from './BranchDialogStore';
import { TemplateDialogStore } from './TemplateDialogStore';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			width: '100%',
		},
		button: {
			marginRight: theme.spacing(1),
		},
		instructions: {
			fontSize: '1rem',
			width: '100%',
			padding: '10px 110px',
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
			minHeight:'365px',
			maxHeight: '365px',
			overflow: 'hidden',
			overflowY: 'auto'
		},
		stepButtons: {
			textAlign: 'center',
			padding: '30px'
		},
		stepLabel: {
			'& .MuiSvgIcon-root': {
				fontSize: '1.8rem'
			},
			'& .MuiStepLabel-label': {
				fontSize: '1.0rem'
			},
			'& .MuiStepLabel-label.MuiStepLabel-completed , & .MuiStepLabel-label.MuiStepLabel-active':{
				fontWeight: 700
			}
		},
		formControlRadio: {
			'& .MuiFormControlLabel-root':{
				textTransform: 'capitalize'
			}
		}

	}),
);

function getSteps() {
	let steps = [
		transl('list.step1'),
		transl('list.step2'),
		transl('list.step3')
	];
	return steps;
}

function getChildSteps(){
	let childSteps = [
		[1,2,3],
		[1,2,3,4,5],
		[1]
	];
	return childSteps;
}

interface NewListAddStepsProps extends StyledComponentProps {
	store: Instance<typeof templateDialogStore>
}

function NewListAddSteps(props: NewListAddStepsProps) {
	const classesStep = useStyles();
	const store = props.store || {};
	const classes = props.classes || {};
	const [showLoader, setShowLoader] = React.useState(0);
	const [activeStep, setActiveStep] = React.useState(0);
	const [activeChildStep, setActiveChildStep] = React.useState(store.childStep);
	const [selectedLocation, setSelectedLocation] = React.useState({id:0,name:''});
	const [hasPromoCode, setHasPromoCode] = React.useState('');
	const [autoInputVal, setAutoInputVal] = React.useState('');
	const [selectedSupplier, setSupplierValue] = React.useState({ name: '', id: 0 } as ISupplier);
	const [addNewLocation, setAddLocation] = React.useState(0);

	const steps = getSteps();
	const childSteps = getChildSteps();
	const omnistore = useOmnistore();

	const _promoSetter = (value: boolean) => store.setUsePromocode(value);

	const getLocationLetter = (locationName) => {
		let locationNameArr = locationName.split(' ');
		let abbr = locationNameArr[0].charAt(0).toUpperCase();
		if (locationNameArr[1]){
			abbr += locationNameArr[1].charAt(0).toUpperCase();
		}else{
			abbr += locationNameArr[0].charAt(1).toUpperCase();
		}
		return abbr;
	};

	const handleLocationSelect = (event, id: number, name: string)=>{
		setLocation(id,name);
		event.target.name = 'branchId';
		event.target.value = id;
		store.applyEvent(event);
		handleNext();
	};

	const setLocation = (id: number, name: string)=>{
		var selected = {
			'id': id,
			'name': name
		};
		setSelectedLocation(selected);
	};

	const handleAddNewLocation=()=>{
		setAddLocation(1);
	};
	const scrollToAddLocationForm = () => {
		const elem = document.getElementById('instructions');
		elem ? elem.scrollTop = elem.scrollHeight : '';
		return elem;
	};
	React.useEffect(() => {
		if (addNewLocation == 1) {
			scrollToAddLocationForm();
		}
	}, [addNewLocation]);

	React.useEffect(() => {
		if (activeChildStep == 2 && activeStep == 0) {
			scrollToSelectedLocation();
		}
	}, [activeChildStep]);

	const handleCancelAddNewLocation = () => {
		setAddLocation(0);
	};

	const acceptAddNewLocation = () => {
		if (branchDialogStore.isValid) {
			setShowLoader(1);
			_onAcceptAddLocation(branchDialogStore, store.setBranchId, true);
		}
	};
	const selectNewLocationCallback = (result, isCall) => {
		if (isCall) {
			setShowLoader(0);
			if (result) {
				setLocation(result.id, result.name);
				setAddLocation(0);
				scrollToSelectedLocation();
			} else {
				scrollToAddLocationForm();
			}
		}
	};

	const scrollToSelectedLocation = () => {
		var locationSelectInterval = setInterval(() => {
			const eelm = document.querySelector('#instructions .Mui-selected');
			if (eelm) {
				eelm.scrollIntoView();
				clearInterval(locationSelectInterval);
				locationSelectInterval == null;
			}
		}, 500);
	};

	const handleChangePromoCode = (event: React.ChangeEvent<HTMLInputElement>) => {
		var usePromocode = (event.target as HTMLInputElement).value;
		setHasPromoCode(usePromocode);
		if (usePromocode === 'yes'){
			_promoSetter(true);
		}else{
			_promoSetter(false);
		}

	};

	const _onAcceptAddLocation = (store: Instance<typeof branchDialogStore>, onAccept, isCall) => {
		store.accept().then((r: IOcResponse) => { onAccept && r.outputObject && onAccept(r.outputObject.id); return r.outputObject; })
			.then((result) => selectNewLocationCallback(result, isCall));
	};

	const _onAcceptAddList = (store: Instance<typeof templateDialogStore>, setCurrentStep) => {
		store.acceptPromise().then(r => {
			if (r.outputObject) {
				setCurrentStep(2, 1);
			}
		});

	};
	const handleFinish=()=>{
		//here close the popup
		store.cancel();
	};

	const handleNext = () => {
		//First step to check the values
		let isNext = true;
		if (activeStep === 0 && activeChildStep === 1){
			isNext = branchDialogStore.isValid;
			if (branchDialogStore.isValid){
				_onAcceptAddLocation(branchDialogStore, store.setBranchId, false);
				setLocation(0,'');
			}
		}

		if (isNext){
			//console.log('activeStep, activeChildStep',activeStep, activeChildStep)

			//promocodeStep
			if (activeStep === 1 && activeChildStep === 1) {
				if (hasPromoCode === 'yes'){
					setCurrentStep(1, 2);
				}else{
					setCurrentStep(1, 3);
				}
			} else if ((activeStep === 1 && activeChildStep === 2) || (activeStep === 1 && activeChildStep === 4) ) {
				if (store.isValid) {
					_onAcceptAddList(store, setCurrentStep);
				}
			} else if ((activeStep === 1 && activeChildStep === 5)) {
				let newSupplierDetails = {
					name: store.supplierName,
					id: 123456
				};
				setSupplierValue(newSupplierDetails as ISupplier);
				setCurrentStep(2, 1);
			}else{
				if (childSteps[activeStep].includes(activeChildStep)) {
					if (activeChildStep === childSteps[activeStep].length) {
						setActiveStep(prevActiveStep => prevActiveStep + 1);
						setActiveChildStep(1);
					} else {
						setActiveChildStep(prevActiveChildStep => prevActiveChildStep + 1);
					}
				} else {
					setActiveStep(prevActiveStep => prevActiveStep + 1);
					setActiveChildStep(1);
				}
			}

		}
		return isNext;
	};

	const handleBack = () => {
		if (activeStep === 2 && activeChildStep === 1 && hasPromoCode === 'yes') {
			setCurrentStep(1, 2);
		}else if (activeStep === 1 && activeChildStep === 5 ) {
			setCurrentStep(1, 3);
		} else if (activeStep === 1 && (activeChildStep === 2 || activeChildStep == 3)) {
			setCurrentStep(1, 1);
		}else if (childSteps[activeStep].includes(activeChildStep)) {
			if (activeChildStep === 1) {
				setActiveStep(prevActiveStep => prevActiveStep - 1);
				setActiveChildStep(childSteps[activeStep-1].length);
			}else{
				setActiveChildStep(prevActiveChildStep => prevActiveChildStep - 1);
			}
		} else {
			setActiveStep(prevActiveStep => prevActiveStep - 1);
			setActiveChildStep(childSteps[activeStep].length);
		}
	};

	const setCurrentStep = (stepNum: number, childStepNum: number)=>{
		setActiveStep(stepNum);
		setActiveChildStep(childStepNum);
	};

	const _renderStepContent = (step: number, childStepCount:number) => {
		switch (step) {
		case 0:
			return _renderStep1(childStepCount);
		case 1:
			return _renderStep2(childStepCount);
		case 2:
			return _renderStep3(childStepCount);
		default:
			return transl('unknownStep');
		}
	};

	const _renderStep1 = (childStepCount:number) => {
		switch (childStepCount) {
		case 1:
			return <BranchDialog store={branchDialogStore} onAccept={store.setBranchId} />;
		case 2:
			return _renderStep1_2();
		case 3:
			return _renderStep1_3();
		default:
			return transl('unknownStep');
		}
	};

	const _renderStep1_2=()=>{
		return <>
			<div className={classes.stepHeading}>
				{transl('location_add.step_1_2')}
			</div>
			<div className={classes.stepContent}>
				<List className={classes.locationChoose}>
					<DialogTitle>{transl('chooseLocation')}</DialogTitle>
					<div className={classes.locationContainer}>
						{store.branchList.map((e: INamedEntity) => (
							<ListItem button key={e.id} onClick={(event)=>handleLocationSelect(event,e.id,e.name)} selected={selectedLocation.id === e.id} >
								<ListItemAvatar>
									<Avatar className={classes.avatar}>
										{getLocationLetter(e.name)}
									</Avatar>
								</ListItemAvatar>
								<ListItemText primary={e.name} />
							</ListItem>
						))}
					</div>
				</List>
			</div>
			<div className={classes.stepContent}>
				<List className={classes.addLocationIcon} >
					<ListItem autoFocus button onClick={handleAddNewLocation}>
						<ListItemAvatar>
							<Avatar>
								<AddIcon />
							</Avatar>
						</ListItemAvatar>
						<ListItemText primary={transl('createBranch')} />
					</ListItem>
				</List>
			</div>
			{
				addNewLocation
					?
					<div className={classes.addLocationStepContent}>
						<BranchAddForm store={branchDialogStore} />
						<div className={classes.LBranchButton}>
							<Button variant="contained" color="primary" onClick={acceptAddNewLocation} className={classesStep.button}>{transl('save')}</Button>
							<Button onClick={handleCancelAddNewLocation} className={classesStep.button}>{transl('cancel')}</Button>
						</div>
					</div>
					:
					''
			}

		</>;
	};

	const _renderStep1_3 = () => {
		return <>
			<div className={classes.stepHeading}>
				{transl('location_add.step_1_2')}
			</div>
			<div className={classes.stepContent}>
				<List className={classes.selectedLocation}>
					<div className={classes.selectedLocationLabel}>{transl('selectedLocation')}:</div>
					<ListItem button onClick={handleBack}>
						<ListItemAvatar>
							<Avatar className={classes.avatar}>
								{getLocationLetter(selectedLocation.name)}
							</Avatar>
						</ListItemAvatar>
						<ListItemText primary={selectedLocation.name} />
					</ListItem>
				</List>
			</div>
		</>;
	};

	const _renderStep2 = (childStepCount: number) => {
		switch (childStepCount) {
		case 1: return _renderStep2_0();
		case 2: return _renderStep2_1();
		case 3: return _renderStep2_2();
		case 4: return _renderStep2_2_1();
		case 5: return _renderStep2_3();
		default:
			return transl('unknownStep');
		}
	};

	const _renderStep2_0 = () => {
		return <>
			<div className={classes.stepHeading}>
				{transl('location_add.step_2_0')}
			</div>
			<div className={classes.step2Content}>
				<FormControl component="fieldset" className={classesStep.formControlRadio}>
					<RadioGroup aria-label="hasPromoCodeAL" name="hasPromoCode" value={hasPromoCode} onChange={handleChangePromoCode}>
						<FormControlLabel value={'no'} control={<Radio />} label={transl('no')} />
						<FormControlLabel value={'yes'} control={<Radio />} label={transl('yes')} />
					</RadioGroup>
				</FormControl>
			</div>
		</>;
	};

	const _renderStep2_1 = () => {
		return <>
			<div className={classes.stepHeading}>
				{transl('location_add.step_2_1')}
			</div>
			<div className={classes.step2Content}>
				<TextField
					className={classes.input}
					required
					name="promocode"
					label={transl('promocode')}
					value={store.promocode}
					error={store.promocode.length !== 7}
					onChange={store.applyEvent}
				/>
			</div>
		</>;
	};

	const _renderStep2_2 = () => {

		const onChangeHandlerA = (event, value) => {
			store.setSupplierId(value.id);
			setSupplierValue(value);
		};

		const getSupplierImageSrc=(supplier)=>{
			const rel = supplier && supplier.imageLink;
			if (!rel) return null;
			return rel.match(/^\/i\//) ? omnistore.authStore.baseUrl + rel : rel;
		};

		const onInputChangeHandlerA = (event, value, reason) => {
			if (reason !== 'reset') {
				setAutoInputVal(value);
			}
			if (value === '') {
				setTimeout(function () {
					var list = document.getElementById('suplier-options-container-popup');
					if(list){
						var liList = list.children;
						for (var i = 0; i < liList.length; i++) {
							if (liList[i].getAttribute('aria-selected') == 'true') {
								var offsetTop = liList[i]['offsetTop'];
								list.scrollTop = offsetTop;
							}
						}
					}
				}, 500);
			}
		};

		return <>
			<div className={classes.step2_2Content}>
				<Autocomplete
					value={selectedSupplier}
					open={true}
					inputValue={autoInputVal}
					noOptionsText={transl('noSupplierText')}
					popupIcon={''}
					onChange={onChangeHandlerA}
					onInputChange={onInputChangeHandlerA}
					disablePortal
					id="suplier-options-container"
					disableClearable
					options={store.supplierList}
					disableCloseOnSelect
					className={classes.supplierListAutocomplete}
					getOptionLabel={option => option.name}
					renderOption={(option, { selected }) => (
						<>
							<Avatar className={classes.avatar} alt={option.name} src={getSupplierImageSrc(option)}>
								{getLocationLetter(option.name)}
							</Avatar>
							<div className={classes.suplierList}>
								<React.Fragment>
									<Checkbox
										icon={icon}
										checkedIcon={checkedIcon}
										style={{ marginRight: 8 }}
										checked={selected}
									/>
									{option.name}
								</React.Fragment>
							</div>
						</>
					)}
					renderInput={(params) => {
						params.InputProps.startAdornment = (<SearchIcon />);
						return (
							<TextField {...params} placeholder="Search..." />
						);
					}}
				/>
				<Link href="#" onClick={() => setCurrentStep(1, 5)}>{transl('location_add.step_2_2')}</Link>
			</div>
		</>;
	};

	const _renderStep2_2_1 = () => {
		return <>
			<div className={classes.step2Heading}>
				{transl('location_add.step_2_2_1_p1')}<br />
				{store.getSupplierName(selectedSupplier.id)}<br />
				{transl('location_add.step_2_2_1_p2')}
			</div>
			<div className={classes.step2_2_1Content}>
				<TextField className={classes.input} required
					name="customerNo"
					label={transl('customerNo')}
					value={store.customerNo}
					error={!store.customerNo}
					onChange={store.applyEvent}
				/>
				<TextField className={classes.input} required
					name="zipcode"
					label={transl('zipcode')}
					value={store.zipcode}
					error={!store.zipcode}
					onChange={store.applyEvent}
				/>

			</div>
		</>;
	};

	const _renderStep2_3 = () => {
		const fieldNames = [
			{ 'field': 'supplierName',label:'name' ,'required': true, width: { xs: 12, sm: 12 } },
			{ 'field': 'customerNo', label: 'customerNumber', 'required': true, width: { xs: 12, sm: 8 } },
			{ 'field': 'supplierEmail', label: 'email', 'required': true, isEmailValid: true, width: { xs: 12, sm: 10 } }

		];
		return <>
			<div className={classes.stepContent}>
				<Grid container spacing={3} className={classes.formGrid}>
					{
						fieldNames.map(n => <Grid item xs={(n.width.xs) as GridSize} sm={(n.width.sm) as GridSize} key={n.field}>
							<TextField
								required={n.required}
								name={n.field}
								label={transl('supplier.'+n.label)}
								value={store[n.field]}
								error={n.isEmailValid ? ((n.required && !store[n.field]) || !store.isEmailValid) : (n.required && !store[n.field]) }
								onChange={store.applyEvent}
							>
							</TextField>
						</Grid>)
					}

					<Grid item xs={12} sm={10}>
						<TextField className={classes.input} select required
							name="industry"
							label={transl('supplier.industry')}
							value={store.industry}
							onChange={store.applyEvent}
						>{store.supplierIndustryList.map((e) => <MenuItem value={e} key={e}>{transl(store.columnSupplierIndustry+'.'+e)}</MenuItem>)}
						</TextField>
						<FormHelperText>{transl('supplier.industryInfoText')}</FormHelperText>
					</Grid>
				</Grid>
			</div>
		</>;
	};

	const _renderStep3 = (childStepCount: number) => {
		switch (childStepCount) {
		case 1:
			return _renderStep3_0();
		default:
			return transl('unknownStep');
		}
	};

	const _renderStep3_0 = () => {
		return <>
			<div className={classes.step3Heading}>
				{transl('location_add.step_3_0_p1')}<br/>
				{store.getBranchName()}<br />
				{transl('location_add.step_3_0_p2')}<br />
				{store.getSupplierName(selectedSupplier.id)}<br />
				{transl('location_add.step_3_0_p3')}
			</div>
		</>;
	};

	const _isNextDisabled=()=>{
		var isNextDisabled = false;
		if (activeStep === 0 && activeChildStep === 2 && selectedLocation.id == 0){
			isNextDisabled = true;
		}

		if (activeStep === 1 && activeChildStep === 1 && hasPromoCode === ''){
			isNextDisabled = true;
		}
		if (activeStep === 1 && activeChildStep === 2 && !store.isValid) {
			isNextDisabled = true;
		}
		if (activeStep === 1 && activeChildStep === 3 && !selectedSupplier.id) {
			isNextDisabled = true;
		}
		if (activeStep === 1 && activeChildStep === 4 && !store.isValid) {
			isNextDisabled = true;
		}

		if (activeStep === 1 && activeChildStep === 5 && !store.isValidSupplier) {
			isNextDisabled = true;
		}
		return isNextDisabled;

	};
	const _isBackHidden = () => {
		var isBackHidden = false;
		if (activeStep === 0 && activeChildStep === 2) {
			isBackHidden = true;
		}
		return isBackHidden;
	};

	return (
		<div className={classesStep.root}>
			<Stepper activeStep={activeStep}>
				{steps.map((label, index) => {
					const stepProps: { completed?: boolean } = {};
					const labelProps: { optional?: React.ReactNode } = {};
					return (
						<Step key={label} {...stepProps}>
							<StepLabel className={classesStep.stepLabel} {...labelProps}>{label}</StepLabel>
						</Step>
					);
				})}
			</Stepper>
			{
				store.isPending || showLoader ?
					<div className={classes.loaderContainer}><PleaseWait /></div>
					:
					<div>
						<div className={classesStep.instructions} id="instructions">{_renderStepContent(activeStep, activeChildStep)}</div>
						<div className={classesStep.stepButtons}>
							{activeStep === steps.length - 1 ? ''
								:
								_isBackHidden() ? '' :
									<Button
										disabled={activeStep === 0 && activeChildStep === 1}
										onClick={handleBack}
										className={classesStep.button}>
										{transl('back')}
									</Button>
							}
							<Button
								variant="contained"
								color="primary"
								disabled={_isNextDisabled()}
								onClick={activeStep === steps.length - 1 ? handleFinish : handleNext}
								className={classesStep.button}
							>
								{activeStep === steps.length - 1 ? transl('finish') : transl('next')}
							</Button>
						</div>
					</div>
			}
		</div>
	);
}

export const templateDialogStore = TemplateDialogStore.create({});

interface IToggleButtonProps<T> {
	className?: string
	name: string
	label?: string
	value: T
	getter() : T | undefined
	setter(value: T) : void
}

@observer class ToggleButton extends React.Component<IToggleButtonProps<boolean>> {
	_onClick = () => this.props.setter(this.props.value)

	@computed get _isPressed() {
		return this.props.getter() === this.props.value;
	}

	private static _disabledClasses = {root: 'ToggleButton-root', label: 'ToggleButton-disabledInputLabel'}
	private static _enabledClasses = {root: 'ToggleButton-root', label: 'ToggleButton-enabledInputLabel'}

	render() {
		let {className, name, label} = this.props;
		if (!label) label = transl(name);
		return <Button className={className}
			classes={this._isPressed ? ToggleButton._disabledClasses : ToggleButton._enabledClasses}
			onClick={this._onClick}
			disabled={this._isPressed}
			variant={this._isPressed ? 'contained' : 'text'}
		>
			{label}
		</Button>;
	}
}

@observer class _TemplateDialog extends React.Component<{store: Instance<typeof templateDialogStore>} & StyledComponentProps> {
	componentDidMount() {
		const multirepo = getOmnistore().multirepo;
		multirepo.branchRepo.fetch();
		multirepo.publicSupplierRepo.fetch();
	}

	_promoGetter = () => this.props.store.usePromocode

	_promoSetter = (value: boolean) => this.props.store.setUsePromocode(value)

	render() {
		const {classes, store} = this.props;
		if (!classes) return null; // impossible
		console.log('Loader isPending ', store.isPending, ' store.isValid ', store.isValid, store.isValidSupplier, 'store.customerNo ',store.customerNo, store.zipcode, store.supplierName, store.industry, store.supplierEmail);
		console.log('branchList Length',store.branchList.length);
		return <Dialog open={store.isVisible} className={classes.root} onClose={store.cancel} fullWidth maxWidth={'md'} disableBackdropClick={true} disableEscapeKeyDown={true}>
			{!store.isShowClose ? '' :
				<DialogTitle>
					<IconButton aria-label="Close" className={classes.closeButton} onClick={store.cancel}><CloseIcon /></IconButton>
				</DialogTitle>
			}
			<DialogContent className={classes.content}>
				<NewListAddSteps classes={classes} store={store} />
				<input type="hidden" value={store.promocode}></input>
			</DialogContent>
		</Dialog>;
	}
}

const styles = createStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		width: '100%',
	},
	input: {
		width: '50%'
	},
	promocodeRow: {
		marginTop: 20,
		marginBottom: 10,
		width: '100%',
		display: 'flex',
		flexDirection: 'row'
	},
	promocodeButton: {
		display: 'flex',
		flex: '1'
	},
	disabledInputLabel: {
		color: '#F00'
	},
	alternatives: {
		minHeight: 210,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center'
	},
	hidden: {
		display: 'none'
	},
	closeButton: {
		position: 'absolute',
		right: '8px',
		top: '8px'
	},
	avatar: {
		backgroundColor: '#1765bd',
		fontWeight: 700,
		cursor: 'pointer'
	},
	checkboxWithAvatar:{
		marginBottom:'10px',
	},
	checkboxWithAvatarLabel:{
		display: 'flex',
		justifyContent: 'space-between',
		textAlign: 'center',
		width: 'calc(100% - 56px)'
	},
	formGrid:{
		width:'70%',
		'& .MuiTextField-root':{
			width:'100%'
		}
	},
	stepHeading: {
		fontWeight: 'bold',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	step2Heading: {
		fontWeight: 'bold',
		width: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign:'center',
		margin: 'auto'
	},

	step3Heading:{
		textAlign: 'center',
		padding: '10%',
		fontWeight: 'bold',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	stepContent:{
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	step2Content:{
		textAlign: 'center',
		padding: '10%'
	},
	step2_2Content:{
		padding: '0 16%',
		textAlign: 'center',
		'& .MuiAutocomplete-popperDisablePortal':{
			position:'relative'
		},
		'& .MuiLink-root':{
			fontWeight:'bold',

		},
		'& .MuiPaper-elevation1': {
			boxShadow: 'none'
		},
		'& .MuiAutocomplete-option': {
			paddingLeft: 0,
			paddingRight: 0
		},
		'& .MuiAutocomplete-listbox':{
			maxHeight: '260px',

			marginBottom: '10px'
		}
	},
	step2_2_1Content: {
		padding: '10px 15%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		textAlign:'center',
		margin: 'auto',
		'& .MuiTextField-root':{
			marginTop: '20px'
		}
	},
	loaderContainer:{
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection:'column',
		minHeight:'474px'
	},
	supplierContainer:{
		maxHeight: '260px',
		overflowY: 'auto',
		marginBottom:'10px'
	},
	locationChoose:{
		border: '1px solid #969696',
		borderRadius: '5px',
		'& .MuiDialogTitle-root .MuiTypography-h6':{
			fontWeight: 'bold',
			textDecoration: 'underline'
		}
	},
	selectedLocation:{
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		paddingTop: '50px',
		'& .MuiListItem-root':{
			width:'auto'
		}
	},
	searchSupplier:{
		width:'90%',
		marginBottom:'10px'
	},
	selectedLocationLabel:{
		fontWeight: 'bold'
	},
	locationContainer:{
		maxHeight: '150px',
		overflowY: 'auto'
	},
	suplierList: {
		display: 'flex',
		width: '100%',
		flexDirection: 'row-reverse',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginLeft: '10px'

	},
	addLocationIcon:{
		top: '20px',
		padding: '0px',
		'& .MuiListItemText-root':{
			flex:'unset'
		},
		'& .MuiListItemAvatar-root':{
			minWidth: '30px'
		},
		'& .MuiAvatar-root.MuiAvatar-circle':{
			width: '25px',
			height: '25px'
		}
	},
	LBranchButton: {
		textAlign: 'right',
		marginTop: '15px',
		'& button': {
			marginRight: '0px',
			marginLeft: '8px',
		}
	},
	addLocationStepContent: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		clear: 'both',
		marginTop: '20px'
	}

});

export const TemplateDialog = withStyles(styles)(_TemplateDialog);
